// extracted by mini-css-extract-plugin
module.exports = {"title":"_25cf7370","link":"_13341130","large":"_a79ba4d","artOneLine":"_940c8c3d","noCreator":"_77985c8d","ellipsis":"_d0d20f05"};